/// <reference path="../appConfig/appConfig.d.ts" />
import { Injectable, Inject} from 'ng-metadata/core';
import {PrimoResponse} from '../infra/dataStructures/PrimoResponses/doc.interfcae';
import {StorageUtil} from "../infra/storageUtil.service";
import {JwtUtilService} from './jwtUtil.service'; 



@Injectable()
export class BrowserStorageManagerService {
    public area: PrimoResponse.IDoc[]| string[];
    

    constructor(private jwtUtilService : JwtUtilService,
                private storageUtil: StorageUtil) {
        
    }

    /*
    adds 'obj' to an array, in a key-value pair in the local forage, 
    which key is 'key'. 
    */
    public addValueToKeyInLocalForage(key, obj) {
        this.storageUtil.$localForage.getItem(key).then((data) => { //gets the array with the key - 'key', into 'data'
            if (data == null){
                data = [];
            }
            data.unshift(obj);
            this.storageUtil.$localForage.setItem(key, data); // put the array back in the local forage with 'obj'.
            
        });   
     }
    
    /*
    cleans Old Items From Local Forage
    */
    public cleanOldItemsFromLocalForage(){        
      let user = this.jwtUtilService.getDecodedToken().user;
      let currentLocalForageKey = user + "_SearchHistoryQeuriesKey";
      this.storageUtil.$localForage.keys().then((allLocalForageKey) => { //gets the array with the key - 'key', into 'data'
            let oldLocalForageKey = allLocalForageKey.filter((key)=>{return ((key.indexOf('SearchHistoryQeuriesKey') !== -1) && (key.indexOf(user) === -1))});
              for (var index in oldLocalForageKey) {
                   this.storageUtil.$localForage.removeItem(oldLocalForageKey[index]);
                }
        });  
      }
    
    /*
    removes 'obj' from an array, in a key-value pair in the local forage, 
    which key is 'key'.
    */
    public removeValueFromKeyInLocalForage(key) {
        this.storageUtil.$localForage.getItem(key).then((data) => {//gets the array with the key - 'key', into 'data'
            data.pop();
            this.storageUtil.$localForage.setItem(key, data); // put the array back in the local forage without 'obj'.
        });   
     }
    
}    


// WEBPACK FOOTER //
// ./src/main/webapp/components/security/browserStorageManager.service.ts